// extracted by mini-css-extract-plugin
export var container = "RCAImage-module--container--bf7a9";
export var curtain = "RCAImage-module--curtain--cfb1f";
export var hasImage = "RCAImage-module--has-image--63c52";
export var noBorder = "RCAImage-module--no-border--89aad";
export var outer = "RCAImage-module--outer--a6de6";